import React, { useState, useCallback, useMemo } from "react";
import { graphql, useStaticQuery } from "gatsby";
import classNames from "classnames";
import { Link } from "./link";
import useClickOut from "../hooks/use-click-out";
import { normalizeRelativePath } from "../utility/paths";

const UtilityLink = ({ className }) => {
  const [supporto, setSupporto] = useState(false);
  const toggleSupporto = useCallback(() => setSupporto((value) => !value), []);
  const supportoRef = useClickOut(supporto, setSupporto);

  // const [it, setIt] = useState(false);
  // const toggleIt = useCallback(() => setIt(value => !value), []);
  // const itRef = useClickOut(it, setIt);

  const {
    assistanceMenuFiltered: { selectNameFieldSet },
  } = useStaticQuery(graphql`
    {
      assistanceMenuFiltered {
        selectNameFieldSet {
          selectName
          page {
            ... on LiferayPage {
              id
              liferayFields {
                title
              }
              slug
            }
            ... on LiferayPageExternalLink {
              id
              liferayFields {
                title
              }
              externalLink
              target
            }
          }
        }
      }
    }
  `);

  const supportPages = useMemo(
    () => selectNameFieldSet?.page?.filter((item) => !!item) || [],
    [selectNameFieldSet]
  );

  return (
    <div className={classNames("utility-link-wrapper", className)}>
      <div className={`utility-link dropdown-menu${supporto ? " open" : ""}`}>
        {supportPages.length ? (
          <>
            <button onClick={toggleSupporto} className="utility-link__btn">
              {selectNameFieldSet.selectName}
            </button>
            <div ref={supportoRef} className="dropdown-menu__content">
              {supportPages.map((item) => (
                <div key={item.id}>
                  {item.slug ? (
                    <Link to={normalizeRelativePath(item.slug)} className="dropdown-menu__link">
                      {item.liferayFields.title}
                    </Link>
                  ) : (
                    <a
                      href={item.externalLink}
                      target={item?.target?.[0]}
                      rel={item?.target?.[0] === "_blank" ? "noopnener noreferrer" : ""}
                      className="dropdown-menu__link"
                    >
                      {item.liferayFields.title}
                    </a>
                  )}
                </div>
              ))}
            </div>
          </>
        ) : null}
      </div>
      {/* <div className={`utility-link dropdown-menu${it ? ' open' : ''}`}>
        <button onClick={toggleIt} className="utility-link__btn" aria-label="Lingua">IT</button>
        <div ref={itRef} className="dropdown-menu__content">
          <div><Link to="/" className="dropdown-menu__link">English</Link></div>
          <div><Link to="/" className="dropdown-menu__link">Deutsch</Link></div>
        </div>
      </div> */}
    </div>
  );
};

export default UtilityLink;
